<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                <span class="text-before-button">{{ pack.name }}</span>
                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_PACKAGES)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editPack()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_DELETE_PACKAGES)"
                  type="danger"
                  icon
                  size="sm"
                  @click="deletePack()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'packages'"
                :objectId="pack.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <package-view-global :pack="pack" />
                </tab-pane>

                <tab-pane title="gallery" id="2">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GALLERY") }}
                  </span>
                  <package-view-gallery :pack="pack" />
                </tab-pane>

                <tab-pane
                  title="authorizations"
                  id="3"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_PERMISSIONS)"
                >
                  <span slot="title">
                    <i class="ni ni-key-25" />
                    {{ $t("USERS.AUTHORIZATIONS") }}
                  </span>
                  <package-view-authorizations :pack="pack" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <package-view-logs :pack="pack" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { cloneDeep } from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import PackageViewGlobal from "./partials/PackageViewGlobal.vue";
import PackageViewLogs from "./partials/PackageViewLogs.vue";
import defaultPackage from "./defaultPackage";
import PackageViewGallery from "./partials/PackageViewGallery.vue";
import PackageViewAuthorizations from "./partials/PackageViewAuthorizations.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    PackageViewGlobal,
    PackageViewGallery,
    PackageViewLogs,
    PackageViewAuthorizations,
    NotificationSubscription,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      pack: cloneDeep(defaultPackage),
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("packages/get", id);
        this.pack = this.$store.getters["packages/package"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editPack() {
      this.$router.push({
        name: "Edit Package",
        params: { id: this.pack.id },
      });
    },

    async deletePack() {
      const confirmation = await swal.fire({
        title: this.$t("PACKAGES.DELETE_THIS_PACKAGE"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("packages/destroy", this.pack.id);
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("PACKAGES.PACKAGE_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List Packages" });
    },
  },
};
</script>
